// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__10LL7","title":"style_title__onC4h","form":"style_form__eEvqL","input":"style_input__Q-MD-","btn":"style_btn__W9-Ze"};